/**
 * Web Font Loader - webフォントの高速読み込み
 *
 * 必要に応じて適宜変更してください。
 *
 * 参考
 * https://firstlayout.net/fast-display-even-with-google-fonts/#toc2
 */


$(function () {
 		window.WebFontConfig = {
 			// 正規
 			google: { families: ['Noto+Sans+JP:wght@400;700&display=swap&subset=japanese', 'Noto+Serif+JP:400,700&display=swap&subset=japanese'] },
//			// アーリーアクセス版
// 			custom: { families: ['Nico Moji'],
// 								urls: ['https://fonts.googleapis.com/earlyaccess/nicomoji.css'] },
 			active: function() {
 				sessionStorage.fonts = true;
 			}
 		};

 		(function() {
 			var wf = document.createElement('script');
 			wf.src = 'https://ajax.googleapis.com/ajax/libs/webfont/1.6.26/webfont.js';
 			wf.type = 'text/javascript';
 			wf.async = 'true';
 			var s = document.getElementsByTagName('script')[0];
 			s.parentNode.insertBefore(wf, s);
 		})();

});
